import mitt from 'mitt'

export default new mitt()

/*
  注册事件：mitt.emit('event-name', key)
  监听事件：mitt.on('event-name', key => {})
  注销事件：mitt.all.delete('event-name')
*/
